import { Schema } from "effect";
export const TalentGeoIP = Schema.Struct({
    iId: Schema.String,
    ip: Schema.String,
    continent_name: Schema.String,
    region_subdivision: Schema.String,
    country_name: Schema.String,
    city: Schema.String,
    accessDate: Schema.Date,
});
